// src/Layouts/ProfileLayout.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { Box, Button, CssBaseline, Toolbar, Typography } from "@mui/material";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useLocation, useHistory } from "react-router-dom";

import NavBar from "../DashboardLayout/NavBar";
import TopBar from "../DashboardLayout/TopBar";

import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";

const useStyles = makeStyles((theme) => ({
    root: {
        background: "#000",
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%",
        minHeight: "100vh",
    },
    wrapper: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        height: "100%",
        width: "100%",
        backgroundImage: 'url("/images/dashboardbg.png")',
        background: "black",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.up("lg")]: {
            paddingLeft: 256,
        },
    },
    contentContainer: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        backgroundPosition: "center",
        backgroundSize: "cover",
        maxWidth: "100%",
        minHeight: "100vh",
    },
    content: {
        flex: "1 1 auto",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        boxShadow: "-6px 0px 8px 0px #090909",
        WebkitOverflowScrolling: "touch",
        padding: "70px 30px",
        [theme.breakpoints.only("xs")]: {
            padding: "70px 10px 10px",
        },
        [theme.breakpoints.only("sm")]: {
            padding: "70px 10px 10px",
        },
    },
}));

const profileTabs = [
    { label: "Personal Details", icon: <PersonIcon />, path: "/profile" },
    { label: "Banking", icon: <AccountBalanceIcon />, path: "/profile-banking" },
    { label: "Nominee", icon: <GroupIcon />, path: "/profile-nominee" },
];

const ProfileLayout = ({ children }) => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className={classes.root}>
            <CssBaseline />
            <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
            <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
            <div className={classes.wrapper}>
                <div className={classes.contentContainer}>
                    <div className={classes.content}>
                        <Toolbar />

                        {/* Profile Heading */}
                        <Box sx={{ textAlign: "left", mb: 2 }}>
                            <Typography variant="h5" fontWeight="bold" color="white">
                                Your Profile
                            </Typography>
                        </Box>

                        {/* Horizontal Profile Tabs */}
                        <Box
                            sx={{
                                display: "flex",
                                overflowX: "auto",
                                bgcolor: "#1a1a1a",
                                px: 2,
                                py: 1,
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                            }}
                        >
                            {profileTabs.map((tab) => (
                                <Button
                                    key={tab.path}
                                    startIcon={tab.icon}
                                    onClick={() => history.push(tab.path)}
                                    sx={{
                                        mx: 1,
                                        color: location.pathname === tab.path ? "white" : "gray",
                                        fontWeight: location.pathname === tab.path ? "bold" : "normal",
                                        borderBottom: location.pathname === tab.path ? "2px solid white" : "none",
                                        whiteSpace: "nowrap",
                                        minWidth: "fit-content",
                                        borderRadius: 0,
                                        textTransform: "none",
                                    }}
                                >
                                    {tab.label}
                                </Button>
                            ))}
                        </Box>

                        {/* Tab Content */}
                        <Box sx={{ mt: 3 }}>
                            {children}
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProfileLayout.propTypes = {
    children: PropTypes.node,
};

export default ProfileLayout;
